import { Box, Button, CircularProgress, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { BsUpload } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { setNotification } from 'redux/notifications/ducks';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => {
  return {
    uploadFileBox: {
      marginTop: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px solid black',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9',
      width: '300px',
      padding: '10px',
      position: 'relative',
      textAlign: 'center',
    },
    uploadedFile: {
      color: '#000',
      textDecoration: 'none',
      fontSize: '12px',
      maxWidth: '120px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    removeFileBtn: {
      background: '#ff4d4d',
      border: 'none',
      color: 'white',
      fontSize: '14px',
      cursor: 'pointer',
      borderRadius: '50%',
      width: '20px',
      height: '20px',
      position: 'absolute',
      top: '5px',
      right: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };
});

function ComplianceUploadUI({ handleSubmit, fileData, setFileData, ...props }) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'application/pdf',
    onDrop: acceptedFiles => {
      if (acceptedFiles[0].type === 'application/pdf') {
        setFileData(acceptedFiles[0]);
      } else {
        dispatch(setNotification('Invalid File Type', 'error', true));
      }
    },
  });

  const renderFileSection = () => {
    if (fileData) {
      return (
        <Box className={classes.uploadFileBox} data-hook='uploaded-file'>
          <Box
            style={{
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '10px',
            }}
          >
            {(fileData.size / (1024 * 1024)).toFixed(2)} MB
          </Box>
          <a
            href={URL.createObjectURL(fileData)}
            target='_blank'
            rel='noopener noreferrer'
            onClick={e => e.stopPropagation()}
            className={classes.uploadedFile}
          >
            {fileData.name}
          </a>
          <button
            onClick={e => {
              e.stopPropagation();
              setFileData(null);
            }}
            className={classes.removeFileBtn}
            data-hook='remove-file-btn'
          >
            &times;
          </button>
        </Box>
      );
    }

    return (
      <Typography>{t('settingsPage.complianceSettings.selectFile')}</Typography>
    );
  };
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      height='100%'
      gap={'16px'}
      bgcolor='#F3F4F6'
      width='100%'
      padding={'30px 137px 30px 137px'}
      data-hook='upload-area'
    >
      <Typography>
        {t('settingsPage.complianceSettings.uploadReport')}
      </Typography>
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        height={72}
        width={72}
        borderRadius={16}
        bgcolor='#FFF'
      >
        <BsUpload size={28} />
      </Box>
      <Box
        {...getRootProps()}
        style={{
          border: '2px dashed #ddd',
          padding: '20px',
          cursor: 'pointer',
          borderRadius: '20px',
        }}
        data-hook='DnD-Box'
      >
        <input {...getInputProps()} />
        {renderFileSection()}
      </Box>
      <Button
        variant='contained'
        color='primary'
        data-hook='pdf-upload-btn'
        disableElevation
        disabled={!fileData}
        // className={props.uploadBtn}
        onClick={handleSubmit}
      >
        {props.isUploading ? (
          <CircularProgress size={30} color='inherit' />
        ) : (
          t('fleetsSection.upload')
        )}
      </Button>
    </Box>
  );
}

export default ComplianceUploadUI;

// Add handleSubmit to props validation
ComplianceUploadUI.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  uploadBtn: PropTypes.string.isRequired,
  isUploading: PropTypes.bool.isRequired,
  setFileData: PropTypes.func.isRequired,
  fileData: PropTypes.object,
};
